(() => {
  if (customElements.get('image-text-slider')) {
    return;
  }

  class ImageTextSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
      this.controls = null;
      this.controlsWrapper = this.querySelector('[data-controls-wrapper]');
      this.shouldDestroyOnDesktop = this.hasAttribute('data-destroy');
      this.contentItems = this.querySelectorAll('[data-content]');
      this.breakpoints = {
        desktop: 990,
      };
    }

    connectedCallback() {
      this.initSlider();
      this.toggleSliderHandler();
      window.addEventListener(
        'resize',
        debounce(this.toggleSliderHandler.bind(this), 500)
      );
    }

    initSlider() {
      const sliderList = this.querySelector('.splide');

      if (!sliderList) return;

      this.controls = this.querySelectorAll('[data-control]');
      this.controls.forEach((control) => {
        control.addEventListener('click', this.onControlClick.bind(this));
      });
      this.slider = new Splide(this.querySelector('.splide'), {
        trimSpace: 'move',
        waitForTransition: true,
        flickMaxPages: 0.5,
        fixedWidth: '41.8rem',
        gap: '4.8rem',
        pagination: false,
        arrows: false,
        speed: 300,
        easing: 'ease-in-out',
        breakpoints: {
          [this.breakpoints.desktop]: {
            fixedWidth: '100%',
            gap: '3.2rem',
          },
        },
      });

      this.slider.on('mounted move', () => {
        const index = this.slider.index;
        const contentItem = this.contentItems[index];
        this.contentItems.forEach(item => {
          item.classList.add('hide')
        });

        contentItem.classList.remove('hide')
      });

      this.slider.mount()
    }

    toggleSliderHandler() {
      if (!this.shouldDestroyOnDesktop) return;
      try {
        this.toggleSlider(window.innerWidth >= this.breakpoints.desktop);
      } catch (e) {}
    }

    toggleSlider(destroy) {
      this.slider[destroy ? 'destroy' : 'mount'](destroy);
      this.controlsWrapper.classList.toggle('hidden', destroy);
    }

    onControlClick(event) {
      event.preventDefault();

      if (this.slider === {}) {
        return;
      }

      const action = event.target.hasAttribute('data-prev') ? '<' : '>';

      this.slider.go(action);
    }
  }

  customElements.define('image-text-slider', ImageTextSlider);
})();
